/**
 * Extracts a typed note payload from a write-back row.
 *
 * @module getNotePayload
 */
import {
  CandidNotePayload,
  CandidWritebackRecord,
} from "../types/candidWriteback";

/**
 * Returns true when `value` looks like a Candid note body.
 *
 * @param value - Unknown payload fragment
 * @returns Whether `value` is a {@link CandidNotePayload}
 */
export const isNotePayload = (value: unknown): value is CandidNotePayload =>
  !!value &&
  typeof value === "object" &&
  !Array.isArray(value) &&
  "note" in value &&
  typeof (value as CandidNotePayload).note === "string";

/**
 * Returns the note body from a write-back row, if present.
 *
 * @param record - Write-back row whose `use_case` is note
 * @returns Note payload, or null when missing
 */
export const getNotePayload = (
  record: CandidWritebackRecord,
): CandidNotePayload | null => {
  const { payload } = record;
  if (!isNotePayload(payload)) {
    return null;
  }
  return payload;
};
